/* Styles */
import "../style/base/_common.scss";
import "../style/components/_utilities.scss";
import "../style/components/_transitions.scss";
import "../style/components/_grid.scss";
import "../style/components/_nav.scss";
import "../style/components/_modal.scss";
import "../style/components/_breadcrumb.scss";
import "../style/components/_buttons.scss";
import "../style/components/_images.scss";
import "../style/components/_forms.scss";
import "../style/components/_box.scss";
import "../style/components/_card.scss";
import "../style/components/_media.scss";
import "../style/layout/_cookie.scss";
import "../style/layout/_map.scss";
import "../style/layout/_header.scss";
import "../style/layout/_listing.scss";
import "../style/layout/_insertion.scss";
import "../style/layout/_details.scss";
import "../style/layout/_filters.scss";
import "../style/layout/_pagination.scss";
import "../style/layout/_footer.scss";
import "../style/vendor/_jquery-ui.scss";
import "../style/vendor/_siema.scss";
import "../style/pages/real-estate-listing.scss";

/* JS */
import "bootstrap/js/dist/dropdown";

import "./components/menu";
import "@wikicasa/common/lazy";

// Use in breadcrumb
import "@wikicasa/common/select";
import "core-js/modules/es.array.iterator";

import * as Common from "@wikicasa/common/common";
import * as Listing from "./components/listing";
import * as Share from "@wikicasa/common/share";
import * as Favourite from "./components/favourite";
import * as Icons from "@wikicasa/common/icons";
import * as Ads from "@wikicasa/common/ads";
import Form from "@wikicasa/common/form/Form";
import IRealEstateMiniItem from "@wikicasa/common/model/RealEstateMiniItem";
import {IInsertion} from "@wikicasa/common/pagination";
import {resendConfirmationEmail} from "./components/login";
import type {IContact} from "./components/contact";

let Filters: any;
let Contact: IContact;
let $saveSearchForm;
let $saveSearchModal: JQuery;
let $emailConfirmModal: JQuery;
let $confirmSaveSearch: JQuery;
let $title: JQuery;

$(() => {

    $saveSearchForm = $("#save-search");
    $saveSearchModal = $("#save-search-modal");
    $emailConfirmModal = $("#email-confirm-modal");
    $confirmSaveSearch = $("#confirmSaveSearch");
    $title = $("#title");

    Listing.init({
        list: "#list-properties",
        getMapMarkers: getMapMarkers,
        buildInfoWindow: buildInfoWindow
    });

    Favourite.init();

    if (!window["_bot"]) {
        updateViewListing(Listing.page.map((re: IInsertion) => ({
            agencyId: re.agencyId,
            realEstateId: re.id
        })));
    }

    const $listAgencies = $("#list-agencies");

    if ($listAgencies) {
        $listAgencies.on("click", "[data-phone]", function (e: JQuery.Event) {
            e.preventDefault();

            const self = this;

            import(/* webpackChunkName: "chunks/contact" */ "./components/contact").then((module: any) => {

                if (!Contact) {
                    Contact = module;
                    Contact.init();
                }

                Contact.showPhone(e, $(self));
            });
        });
    }

    Common.observe("#filters-form-main, #filters-form-mobile", (elem: HTMLElement, observer: IntersectionObserver) => {

        import(/* webpackChunkName: "chunks/filters" */ "./components/filters").then((module: any) => {

            Filters = module;

            Filters.init({
                map: "#filters-map",
                formMain: "#filters-form-main",
                formExtend: "#filters-form-extend",
                formMobile: "#filters-form-mobile",
            });

            Filters.ready(() => {
                Filters.loadSearch(Common.getSearch());

                Listing.on("shape.confirm", () => {
                    const points = Listing.getMap().getShapePoints();
                    Filters.toggleMap();
                    Filters.submitSearch(null, {
                        "Poligono": Common.encodePoints(points)
                    });
                });

                Listing.on("shape.deleted", () => {
                    Filters.toggleCity();
                });
            });
        });

        observer.disconnect();
    });

    Share.init();

    if ($saveSearchForm.get(0)) {
        const saveSearchForm = new Form($saveSearchForm);
        saveSearchForm.onSubmit((e: JQuery.SubmitEvent): void => {
            e.preventDefault();

            if (!saveSearchForm.validate(true)) {
                saveSearchForm.clearSubmit();
                return;
            }

            const data = {email: saveSearchForm.getValues().email || window["_email"]};
            if (saveSearchForm.getValues().title)
                $.extend(data, {title: saveSearchForm.getValues().title});

            const email = saveSearchForm.getValues().email || window["_email"];
            const title = saveSearchForm.getValues().title || "";

            saveSearch(email, title, window["_serializedSearchBean"]).done(() => {
                saveSearchForm.clear();
                saveSearchForm.clearSubmit();
                $saveSearchModal.modal("hide");
                $("#save-search-modal-success").modal("show");
                window["dataLayer"].push({
                    "event": "GAevent",
                    "eventCategory": "Newsletter",
                    "eventAction": "Ricerca salvata",
                    "eventLabel": "Form",
                    //GA4
                    "event_name": "mail_alert_save",
                    "event_location": "Modale Mail Alert",
                });
            }).fail((error: JQuery.jqXHR) => {
                switch (error.status) {
                    case 401:
                        $saveSearchModal.modal("hide");
                        $("#save-search-modal-unauthorized").modal("show");
                        break;
                    case 405:
                        $saveSearchModal.modal("hide");
                        $("#save-search-modal-limit-saved-not-logged").modal("show");
                        break;
                    case 409:
                        $saveSearchModal.modal("hide");
                        $("#save-search-modal-limit-saved-logged").modal("show");
                        break;
                    case 412:
                        $saveSearchModal.modal("hide");
                        $("#save-search-modal-limit").modal("show");
                        break;
                    default:
                        console.error(error.responseText);
                        $title.next().html("Si è verificato un errore imprevisto!");
                        $title.addClass("error");
                }
                Icons.removeSpinner(saveSearchForm.getButton());
            });
        });
    }

    $confirmSaveSearch.on("click", () => {
        Icons.addSpinner($confirmSaveSearch);
        resendConfirmationEmail($confirmSaveSearch.data("email"))
            .done(() => {
                $saveSearchModal.modal("hide");
                $emailConfirmModal.modal("show");
            }).always(() => Icons.removeSpinner($confirmSaveSearch))
    });

    const $disclaimer = $("#disclaimer");

    $disclaimer.modal("show");
    $disclaimer.find("[data-target]").on("click", () => $disclaimer.modal("hide"));

    Ads.init();
});

function buildInfoWindow(ids: Array<number>): Promise<string> {

    return new Promise((resolve: (str: string) => void) => {

        getRealEstatesData(ids).done((data: Array<IRealEstateMiniItem>) => {

            if (!data)
                return;

            let html = `<p class="mb-15">${window["_insertionsLabel"]}</p>`;
            html += `<ul class="list-multiple list-unstyled mb-0">${buildListHtml(data)}</ul>`;

            resolve(html);
        });
    })
}

function buildListHtml(realEstates: Array<IRealEstateMiniItem>): string {

    let html = "";

    for (let i = 0; i < realEstates.length; i++) {
        const realEstate = realEstates[i];

        // eslint-disable-next-line max-len
        html += `<li class="media" data-id="${realEstate.realEstateID}" data-url="${realEstate.url}" data-target="_blank"><div class="media-left">`;
        // eslint-disable-next-line max-len
        const img = `https://www.wikicasa.it/rest/realEstate/${realEstate.realEstateID}/images/${realEstate.description?.toLowerCase().replace(" ", "-")}_foto-1_small.jpg`;

        html += `<div class="media-thumbnail img-cover img-4-3" style="background-image: url('${img}');">`;

        if (!realEstate.publishMap)
            html += `<div class="media-warning f-12 text-center text-white">${window["_approximatePositionLabel"]}</div>`;

        html += "</div></div><div class=\"media-body py-6 property-details\">";

        html += "<h4 class=\"font-weight-semibold my-6";

        if (realEstate.reservedPrice) {
            html += " price-reserved\">" + window["_labelReservedPrice"];
        } else if (realEstate.sale) {
            html += `">&euro; ${Common.formatCurrency(realEstate.priceSale)}`;
        } else
            html += `">&euro; ${Common.formatCurrency(realEstate.priceRent)}`;

        html += "</h4>";

        html += `<p class="text-uppercase my-6">${realEstate.description}</p>`;
        html += `<ul class="list-inline list-unstyled mb-0">`;
        if (realEstate.sqm && realEstate.sqm > 0) {
            // eslint-disable-next-line max-len
            html += `<li class="list-inline-item">${Common.formatInteger(realEstate.sqm)}&nbsp;<small>m<sup>2</sup></small></li>`;
        }

        if (realEstate.rooms)
            // eslint-disable-next-line max-len
            html += `<li class="list-inline-item bullet-left">${Common.formatInteger(realEstate.rooms)}&nbsp;<small>${window["_labelRooms"]}</small></li>`;

        if (realEstate.bathrooms)
            // eslint-disable-next-line max-len
            html += `<li class="list-inline-item bullet-left">${Common.formatInteger(realEstate.bathrooms)}&nbsp;<small>${window["_labelBathrooms"]}</small></li>`;

        html += "</ul>";

        const isFav = Favourite.indexOf(realEstate.realEstateID) > -1;

        html += `<ul class="list-inline media-buttons mb-0"><li class="list-inline-item mx-0 px-15">`;
        // eslint-disable-next-line max-len
        html += `<a role="button" class="fav fav-save" data-id="${realEstate.realEstateID}" data-url="${realEstate.url}" style="display:${isFav ? "none" : "block"};">`;
        html += `<img height="32px" width="32px" class="icon icon-md" src="${window["_cdn"]}/_ui/img/Icons/save-off-arancione.svg"/></a>`;
        // eslint-disable-next-line max-len
        html += `<a role="button" class="fav fav-remove" data-id="${realEstate.realEstateID}" data-url="${realEstate.url}" style="display:${isFav ? "block" : "none"};">`;
        html += `<img height="32px" width="32px" class="icon icon-md" src="${window["_cdn"]}/_ui/img/Icons/save-on-arancione.svg"/></a>`;
        html += `</li><li class="list-inline-item mx-0 px-15 border-left">`;
        html += `<a class="share" data-title="${realEstate.description}" data-url="${window._baseURL}${realEstate.url}?utm_source=share&utm_campaign=Listato">`;
        html += `<img height="32px" width="32px" class="icon icon-md" src="${window["_cdn"]}/_ui/img/Icons/Share-ar.svg"/></a>`;
        html += `</li></ul>`;

        html += "</div></li>";
    }
    html += "";
    return html;
}

function getRealEstatesData(ids: Array<number>): JQueryPromise<unknown> {
    return $.ajax({
        method: "POST",
        dataType: "json",
        contentType: "application/json",
        url: `/rest/realEstate/getRealEstateListForInfoWindow/${window["_locale"]}`,
        data: JSON.stringify(ids)
    });
}

function getMapMarkers(): JQueryPromise<unknown> | undefined {

    if (!window["_serializedSearchBean"])
        return;

    const searchBean = $.extend({}, JSON.parse(window["_serializedSearchBean"]));

    delete searchBean["latitude"];
    delete searchBean["longitude"];

    return $.ajax({
        type: "POST",
        url: "/rest/realEstate/getMapMarkers",
        data: JSON.stringify(searchBean),
        contentType: "application/json; charset=utf-8",
    });
}

function updateViewListing(data: Array<{ agencyId: number; realEstateId: number }>): JQueryPromise<any> {
    return $.ajax({
        type: "POST",
        url: "/rest/statistics/updateViewListing/C",
        data: JSON.stringify(data),
        contentType: "application/json",
    });
}

function saveSearch(email: string, title: string, searchBean: any): JQueryPromise<any> {
    return $.ajax({
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: searchBean,
        url: `/rest/realEstate/saveSearch?email=${email}&title=${title}`
    });
}